var _path, _path2, _path3, _g, _path4, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBallot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M61.3 54.7l-51 9.3l-2.4-43.3L64 18.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c94747",
    d: "M10.3 64L2.6 49.4L0 15.5l7.9 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#881a0e",
    d: "M64 18.3L7.9 20.7L0 15.5l42.1-1.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 30.1l2.8-.1L22 48.2l-2.6.3l-4.3-17.9l3.1-.2L20.9 44L24 30.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 44.8c-.9 1.4-2.2 2.2-4 2.5c-1.7.2-3.1-.3-4-1.5c-1.2-1.5-1.8-3.9-1.8-7c.1-3.2.8-5.7 2.1-7.4c1-1.4 2.3-2.1 4.1-2.2c1.7-.1 3 .5 3.9 1.8c1.1 1.5 1.7 3.7 1.6 6.8c-.1 2.9-.7 5.3-1.9 7M36 42.4c.6-1.1.9-2.6.9-4.5s-.2-3.3-.8-4.3c-.6-1-1.3-1.5-2.3-1.4c-1 .1-1.8.6-2.4 1.7c-.6 1.1-1 2.6-1 4.6c0 2 .2 3.4.8 4.4c.6 1 1.4 1.4 2.4 1.3c1-.1 1.8-.7 2.4-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3 28.8v2.8l-3.2.2l-.2 13.4l-2.3.3l.2-13.5l-3.4.2l.1-3l8.8-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1 31.1l-5.3.3l-.1 3.4l4.9-.4v2.7l-4.9.4l-.1 4.1l5.6-.6v2.8l-7.7.9l.3-16l7.5-.4l-.2 2.8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 0l-34 .6c2.3 10 .1 18.2.1 18.2l34-1.6c0 .1 2.2-7.1-.1-17.2",
    fill: "#dfe9ef"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#83bf4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8 6.8c-5.8.1-11.5.2-17.3.4V5.8c5.8-.2 11.5-.3 17.3-.4v1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.7c-.1.2-.3.2-.5.1c-.8-.7-1.7-1.3-2.5-2c-.2-.1-.2-.3 0-.5c.1-.1.2-.2.3-.2c.2-.1.4-.1.6 0c.5.3.9.7 1.4 1c.2.1.4.1.5-.1c.6-.9 1.1-1.8 1.6-2.7c.1-.2.3-.2.6-.2c.1 0 .3.1.4.1c.1.2.2.4.1.6c-.8 1.3-1.6 2.6-2.5 3.9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#93a2aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2 15.1c-5.8.1-11.6.3-17.4.4c.1-.5.1-.9.2-1.4c5.8-.1 11.6-.2 17.4-.4c-.1.5-.2.9-.2 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 17.2c-1.9 0-3.8.1-5.7.1c.2-1.6.4-3.1.6-4.7c1.9 0 3.8-.1 5.7-.1c-.2 1.5-.4 3.1-.6 4.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallot);
export default __webpack_public_path__ + "static/media/ballot.054cc9dccc90162f006e7a4df7d1bf5d.svg";
export { ForwardRef as ReactComponent };